"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TAX_TYPES = exports.TAX_EFFECTS = void 0;
var TAX_EFFECTS = exports.TAX_EFFECTS = ['RETENIDO', 'TRASLADADO'];
var TAX_TYPES = exports.TAX_TYPES = ['ISR', 'IVA', 'IEPS'];